'use client';

import { Analytics } from '@vercel/analytics/next';
import { SpeedInsights } from '@vercel/speed-insights/next';
import { isRenderRoom } from '@/components/quiz/kit/carousel/render-protocol';

/** Vercel's two meters, minus the render iframe every post screen opens. */
export function SiteAnalytics() {
  const skip = <E extends { url: string }>(event: E) =>
    isRenderRoom(new URL(event.url).pathname) ? null : event;
  return (
    <>
      <Analytics beforeSend={skip} />
      <SpeedInsights beforeSend={skip} />
    </>
  );
}
